import { Serializer } from "../resource/serializer.interface";
import { CorePreference } from "./core-preferences.model";

export class CorePreferenceSerializer implements Serializer {
    fromJson(json: any): CorePreference {
        const corePreference = new CorePreference();
        corePreference.id = json.id;
        corePreference.name = json.name;
        corePreference.type = json.type;
        corePreference.label = json.label;
        corePreference.businessUnit = json.businessUnit;
        corePreference.translations = json.translations ?? {};
        corePreference.customCSS = json.customCSS;
        corePreference.isRequired = json.isRequired;
        corePreference.internalDescription = json.internalDescription;
        corePreference.description = json.description;
        corePreference.status = json.status;
        corePreference.frequenciesIds = json.frequenciesIds;
        corePreference.channelsIds = json.channelsIds;
        corePreference.tenantId = json.tenant_id;
        corePreference.internalID = json.internalID;
        corePreference.preferenceCatalogId = json.preferenceCatalogId;
        return corePreference;
    }

    toJson(corePreference: CorePreference): any {
        return {
            id: corePreference.id,
            name: corePreference.name,
            type: corePreference.type,
            label: corePreference.label,
            businessUnit: corePreference.businessUnit,
            translations: corePreference.translations,
            customCSS: corePreference.customCSS,
            isRequired: corePreference.isRequired,
            internalDescription: corePreference.internalDescription,
            description: corePreference.description,
            status: corePreference.status,
            frequenciesIds: corePreference.frequenciesIds,
            channelsIds: corePreference.channelsIds,
            tenant_id: corePreference.tenantId,
            internalID: corePreference.internalID,
            preferenceCatalogId: corePreference.preferenceCatalogId,
        };
    }
}
